import { render, staticRenderFns } from "./DefectSelect.vue?vue&type=template&id=055e52b8"
import script from "./DefectSelect.vue?vue&type=script&lang=ts"
export * from "./DefectSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports